import { Controller } from "@hotwired/stimulus"

// Редактор пула сюжетов в админке: строки добавляются и удаляются на месте.
//
// Индексов в именах полей нет (`suggestions[][label]`), поэтому и клонировать
// нечего пересчитывать — Rails собирает пары по повторяющемуся ключу. Удалённая
// строка просто исчезает из формы, дыры в нумерации не остаётся.
export default class extends Controller {
  static targets = ["rows", "template", "row"]

  add(event) {
    event.preventDefault()
    const row = this.templateTarget.content.firstElementChild.cloneNode(true)
    this.rowsTarget.appendChild(row)
    // Курсор в подпись: строку добавляют, чтобы сразу писать.
    row.querySelector("input")?.focus()
  }

  remove(event) {
    event.preventDefault()
    event.target.closest("[data-idea-pool-target='row']")?.remove()
  }
}
